import { useState } from 'react';
import { useAppStore } from '../store/useAppStore.js';
import { supabase } from '../lib/supabase.js';
import { AlertIcon } from '../icons.js';
import { PasswordField } from '../PasswordField.js';

export function ResetPasswordView() {
  const setView = useAppStore((s) => s.setView);
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const { error: upErr } = await supabase.auth.updateUser({ password });
      if (upErr) throw new Error(upErr.message);
      // Sign out so the user is forced through the new password on next sign-in.
      await supabase.auth.signOut();
      setView('login');
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="max-w-md mx-auto card p-7 lg:p-10 has-grain animate-fade-up">
      <h2 className="h-card mb-6 text-ink-900 dark:text-ink-100">Set a new password</h2>

      <form onSubmit={onSubmit} autoComplete="on" className="flex flex-col gap-5">
        <PasswordField label="New password" value={password} onChange={setPassword}
          autoComplete="new-password" minLength={6} required />
        <button type="submit" className="btn-primary w-full justify-center" disabled={submitting}>
          {submitting ? 'Updating…' : 'Update password'}
        </button>
      </form>

      {error ? (
        <div className="notice-error mt-5">
          <AlertIcon className="shrink-0 mt-0.5" />
          <span>{error}</span>
        </div>
      ) : null}
    </div>
  );
}
